<template>
  <b-card
    :id="`product-${product.id}`"
    class="rounded-5 h-100 p-1 mb-0"
    no-body
    @click="add"
  >
    <b-card-title class="m-0 p-0">
      <b-row>
        <b-col
          sm="auto"
          class="pl-1 pr-0"
        >
          <b-img
            v-if="false"
            width="60px"
            rounded
            :src="`${product.logo}`"
          />
        </b-col>
        <b-col class="d-flex flex-column justify-content-between">
          <h5 class="mb-0">
            {{ product.name }}
          </h5>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <b-badge
                pill
                variant="primary"
                class="text-small"
              >
                {{ product.category.name }}
              </b-badge>
            </div>
            <span class="text-muted text-small">
              {{ product.sku }} -
              <span class="font-weight-bolder text-dark">
                {{ product.brand || 'N/A' }}
              </span>
            </span>
          </div>
        </b-col>
      </b-row>
    </b-card-title>
    <b-row
      v-if="!cart"
      class="d-flex flex-column"
    >
      <b-col sm="12">
        <div class=" d-flex flex-column">
          <div class="mt-1">
            <div class="text-muted text-justify text-small">
              {{ product.description }}
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row
      v-else
      class="mt-1"
    >
      <b-col class="d-flex justify-content-between align-items-center">
        <b-form-group
          v-if="validRole"
          :label="
            $route.name === 'registerSupplierProduct'
              ? $t('unitPrice')
              : 'Cantidad'
          "
          label-for="input-sm"
        >
          <b-input-group size="sm">
            <b-form-input
              :value="product.quantity"
              :type="$route.name === 'registerSupplierProduct' ? 'text' : 'number'"
              :inputmode="$route.name === 'registerSupplierProduct' ? 'decimal' : null"
              :min="$route.name === 'registerSupplierProduct' ? 0 : 1"
              :step="$route.name === 'registerSupplierProduct' ? '0.000001' : '0.01'"
              class="qty-field"
              autocomplete="off"
              :formatter="limitDecimalPlaces"
              @input="setQuantity"
            />
            <b-input-group-append is-text>
              {{ $tc(unitsFilter(product.unit_type)) }}
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-button
          size="sm"
          variant="outline-danger"
          class="d-flex custome-button"
          @click="remove(index)"
        >
          <feather-icon
            icon="TrashIcon"
            class="custom-margin"
          />
          {{ $t('delete') }}
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  components: {},

  props: {
    product: {
      type: Object,
      default: () => ({
        name: '',
        category: '',
        categories_ids: [],
        img: '',
        price: 0,
        cost: 0,
        variant: '',
      }),
    },
    index: {
      type: Number,
      default() {
        return null
      },
    },
    cart: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isModalVisible: false,
      selectedProduct: {},
    }
  },
  computed: {
    ...mapGetters('auth', ['currentUser']),
    ...mapGetters('pos', ['posItems']),
    ...mapGetters('app', ['unitsFilter']),
    validRole() {
      if (this.$route.name === 'addProductsToQuote') return true
      if (
        this.currentUser.role_name === 'admin'
        || this.currentUser.role_name === 'auctioneer'
      ) return true
      return false
    },
    maxDecimalPlaces() {
      return this.$route.name === 'registerSupplierProduct' ? 6 : 2
    },
  },
  mounted() {},
  methods: {
    ...mapMutations('pos', {
      addProduct: 'ADD_ITEM_TO_POS',
      removeProduct: 'REMOVE_ITEM_FROM_POS',
      changeQuantity: 'CHANGE_ITEM_QUANTITY',
    }),

    add() {
      if (
        !this.posItems.find(item => item.id === this.product.id)
        && !this.cart
      ) {
        this.addProduct({ ...this.product })
      }
    },
    remove(index) {
      this.removeProduct({ index })
    },
    limitDecimalPlaces(value) {
      const stringValue = String(value ?? '').replace(',', '.')
      const [integerPart, ...decimalParts] = stringValue.split('.')
      const sanitizedInteger = integerPart.replace(/\D/g, '')
      const decimalPart = decimalParts.join('').replace(/\D/g, '')

      if (decimalParts.length === 0) return sanitizedInteger

      return `${sanitizedInteger}.${decimalPart.slice(0, this.maxDecimalPlaces)}`
    },
    setQuantity(value) {
      this.changeQuantity({
        item: this.product,
        value: this.limitDecimalPlaces(value),
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.text-small {
  font-size: 11px;
}
.custome-button {
  padding-left: 2px;
  padding-right: 2px;

  .custom-margin {
    margin-right: 3px;
  }
}

.qty-field {
  max-width: 80px;
}
</style>
